import { vehicleRoutes } from "./vehicle";
import { clientRoutes } from "./client";
import { transferRoutes } from "./vehicle/transferRoutes";
import { authRoutes } from "./auth";
import { checklistRoutes } from "./checklist";
import { dashboardRoutes } from "./dashboard/dashboardRoutes";

export interface RouteConfig {
  path: string;
  component: React.LazyExoticComponent<React.ComponentType<any>>;
  private?: boolean;
  adminOnly?: boolean;
}

export const routes: RouteConfig[] = [
  ...authRoutes,
  ...dashboardRoutes,
  ...vehicleRoutes,
  ...clientRoutes,
  ...checklistRoutes,
  ...transferRoutes,
];
